// ChatModal.jsx
import React from 'react';
import ChatContainer from '../ChatContainer/ChatContainer';
import './ChatModal.scss';

const ChatModal = ({ isOpen, onClose, ...props }) => {
  if (!isOpen) return null;

  return (
    <div className="chat-modal-overlay" onClick={onClose}>
      <div className="chat-modal-content" onClick={(e) => e.stopPropagation()}>
        <ChatContainer {...props} onClose={onClose} isOpen={true} />
      </div>
    </div>
  );
};

export default ChatModal;